import cookie from 'react-cookies';

const getClientId = () => cookie.load('abn_test') ?? 'client id is not defined';

/**
 * Получение clientId из Google Tag Manager
 */
export const getGaId = () => {
    let clientId = cookie.load('_ga_cid');

    if (!clientId) {
        try {
            clientId = window.ga
                ? window.ga.getAll()[0].get('clientId')
                : getClientId();
        } catch (e) {
            clientId = getClientId();
        }
    }
    return clientId;
};
